import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component} from "@angular/core";
import {IPaiementWebServiceClient, PaiementDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'patient-component',
  templateUrl: './patient.component.html',
  host: { 'class': 'page' }
})
export class PatientComponent {

  paiement: PaiementDto = null;
  factureForm: FormGroup;
  errorSaisie: boolean;
  affichageNext: boolean;

  patientCorrect: boolean = false;
  anapath: boolean = false;
  labelNumDossier: string = "Patient.Form.numDossier";

  constructor(private fb: FormBuilder,
              private paiementWebServiceClient: IPaiementWebServiceClient,
              private activatedRoute: ActivatedRoute) {

    this.paiement = activatedRoute.snapshot.data['paiements'][0] || null;
  }

  ngOnInit() {

    this.affichageNext = false;
    this.errorSaisie = false;
    if (this.paiement == null) {
      this.factureForm = this.fb.group({
        numPatient: [null, Validators.required],
        numDossier: [null, Validators.required],
      });
    } else if (this.paiement != null) {
      this.factureForm = this.fb.group({
        numPatient: [this.paiement.code, Validators.required],
        numDossier: [this.paiement.numero, Validators.required],
      });
    }

    this.factureForm.valueChanges.debounceTime(500).subscribe(() => this.handleNumPatient());
    this.factureForm.valueChanges.subscribe(() => this.errorSaisie = false);

    if (this.paiement) {
      this.handleNumPatient();
      this.handlePaiement(this.paiement);
    }
  }

  handleNumPatient(): void {
    this.paiementWebServiceClient.isPresent(this.factureForm.value.numPatient).subscribe((res) => {
      this.patientCorrect = res.present;
      this.anapath = res.anapath;
      this.labelNum();
    });
  }

  submit() {
    this.errorSaisie = false;
    if (this.factureForm.valid === true) {
      let values = this.factureForm.value;
      this.loadPaiement(values)
    }
  }

  loadPaiement(values: any) {
    this.paiementWebServiceClient.findPaiementPatient(values.numPatient, values.numDossier).subscribe(
      data => this.handlePaiement(data),
      err => {
        this.errorSaisie = true;
        console.log(err);
      });
  }

  handlePaiement(data: PaiementDto): void {
    this.paiement = data;
    if (data === null || data.etat == "PAYE") {
      this.errorSaisie = true;
      this.affichageNext = false;
    } else {
      this.affichageNext = true;
    }
  }

  public doSomething(event: any): void {
    this.affichageNext = false;
  }

  labelNum() {
    if (this.anapath) {
      this.labelNumDossier = "Patient.Form.numDossier";
    } else {
      this.labelNumDossier = "Patient.Form.numFacture";
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/patient/patient.component.ts